import React, { useEffect, useState } from "react";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import { contactApi } from "@/main/api";
import { ContactByCompanyRequest } from "@/main/models/request";
import { getTranslateByKey } from "@/main/services/utils";
import KogModalSideComponent from "@/main/components/modal/ModalSide";
import { ContactResponse } from "@/main/models/response";
import AccordionContacts, { IInfoProcurement } from "./accordionContacts/accordionContacts";
import * as S from "./styles";
import LoadingComponent from "../loading/loadingComponent";

interface IModalContactsProps {
	guidCompany: string;
	open: boolean;
	infoProcurement: IInfoProcurement;
	closeModal: () => void;
}

interface IContactResponseStates {
	primaryContact: ContactResponse[];
	otherContacts: ContactResponse[];
}

const INITIAL_STATE_CONTACTS = {
	primaryContact: [],
	otherContacts: [],
} as IContactResponseStates;

function ModalContacts({ guidCompany, open, infoProcurement, closeModal }: IModalContactsProps) {
	// States

	const [dataContacts, setDataContacts] = useState<IContactResponseStates>(INITIAL_STATE_CONTACTS);
	const [isLoadingContacts, setIsLoadingContacts] = useState<boolean>(false);
	const [currentCollapse, setCurrentCollapse] = useState<string | false>("");
	// Core function
	const handleChangeCollapse = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
		event.stopPropagation();
		event.preventDefault();
		setCurrentCollapse(isExpanded ? panel : false);
	};
	// Async function
	async function fetchDataContacts(request: ContactByCompanyRequest) {
		setIsLoadingContacts(true);

		return contactApi
			.getContactsListByCompany(request)
			.then((response) => {
				const { result } = response.data;

				const primaryContact = result.filter((c) => c.principal);
				const otherContacts = result.filter((c) => !c.principal);
				const contactsResult = {
					primaryContact,
					otherContacts,
				} as IContactResponseStates;

				setDataContacts(contactsResult);
			})
			.finally(() => {
				setIsLoadingContacts(false);
			});
	}
	// Initial load
	useEffect(() => {
		if (open) {
			const request = {
				guidCompany,
			} as ContactByCompanyRequest;
			fetchDataContacts(request);
		}
	}, [open]);

	return (
		<KogModalSideComponent
			open={open}
			withStopPropagation
			title={getTranslateByKey("information.contactsInformation")}
			closeModal={() => closeModal()}
		>
			<S.Container>
				{isLoadingContacts ? (
					<LoadingComponent />
				) : (
					<>
						<AccordionContacts
							title={getTranslateByKey("information.primaryContact")}
							dataContacts={dataContacts.primaryContact}
							infoProcurement={infoProcurement}
							propsCollapse={{
								expanded: currentCollapse === "panelcontacts1" || currentCollapse === "",
								onChange: handleChangeCollapse("panelcontacts1"),
								defaultExpanded: false,
							}}
						/>
						{dataContacts.otherContacts.length > 0 && (
							<AccordionContacts
								title={getTranslateByKey("information.otherContacts")}
								dataContacts={dataContacts.otherContacts}
								infoProcurement={infoProcurement}
								propsCollapse={{
									expanded: currentCollapse === "panelcontacts2" || currentCollapse === "",
									onChange: handleChangeCollapse("panelcontacts2"),
									defaultExpanded: false,
								}}
							/>
						)}
					</>
				)}
				<SecondaryButton id="id-modalContact-button-back" onClick={() => closeModal()}>
					{getTranslateByKey("information.back")}
				</SecondaryButton>
			</S.Container>
		</KogModalSideComponent>
	);
}

export default ModalContacts;
